"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getApplangaRequestUrl = exports.encodeArray = void 0;
exports.getTranslationsUrl = getTranslationsUrl;
exports.load = load;
exports.translationsEndpoint = exports.qaBaseUrl = exports.prodBaseUrl = void 0;

var _crossFetch = _interopRequireDefault(require("cross-fetch"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const prodBaseUrl = "https://api.ww.com";
exports.prodBaseUrl = prodBaseUrl;
const qaBaseUrl = "https://api.qa.ww.com";
exports.qaBaseUrl = qaBaseUrl;
const translationsEndpoint = "/v1/i18n/translations?";
exports.translationsEndpoint = translationsEndpoint;
const PROD = "production";
const QA = "qa";
const defaultOptions = {
  requestedGroups: ["main"],
  includeDraft: false
};

async function load(options, logError = false) {
  let translations = {};
  options = { ...defaultOptions,
    ...options
  };

  if (!options.app) {
    throw new Error("The Applanga app id is missing");
  }

  if (!options.apiKey) {
    throw new Error(`The Applanga apiKey is missing on appID=${options.app}`);
  }

  try {
    translations = await fetchTranslations(options, logError);
  } catch (e) {
    if (logError) {
      console.error(`load's fetchTranslations failed on appID=${options.app}:`, e);
    }
  }

  function fetchLocale(locale) {
    return translations[locale];
  }

  function getTranslations() {
    return translations;
  }

  function keepAlive(ttl = 300000, callback = () => {}, logError = false) {
    setTimeout(async () => {
      try {
        translations = await fetchTranslations(options, logError);
      } catch (e) {
        if (logError) {
          console.error(`keepAlive's fetchTranslations failed on appID=${options.app}:`, e);
        }
      }

      try {
        if (typeof callback === "function") {
          callback();
        }
      } catch (e) {
        if (logError) {
          console.error(`keepAlive's callback errored on appID=${options.app}:`, e);
        }
      }

      keepAlive(ttl, callback, logError);
    }, ttl);
  }

  return {
    getTranslations,
    fetchLocale,
    keepAlive
  };
}

const encodeArray = arr => {
  if (!Array.isArray(arr)) {
    return "[]";
  }

  arr = arr.map(val => `%22${val}%22`).join(",");
  return `[${arr}]`;
};

exports.encodeArray = encodeArray;

const getApplangaRequestUrl = params => {
  const queries = Object.keys(params).reduce((pairs, key) => {
    if (key === "apiKey") {
      return pairs;
    }

    let value = params[key];
    value = Array.isArray(value) ? encodeArray(value) : value;
    return pairs += `&${key}=${value}`;
  }, "");
  return `https://api.applanga.com/v1/api?${queries.substring(1)}`;
};

exports.getApplangaRequestUrl = getApplangaRequestUrl;

async function fetchTranslations(options, logError) {
  const url = getApplangaRequestUrl(options);
  const fetchOptions = {
    headers: {
      Authorization: `Bearer ${options.apiKey}`
    }
  };
  const response = await (0, _crossFetch.default)(url, fetchOptions);

  if (!response.ok) {
    throw response;
  }

  const data = await response.json();
  const translations = data.data;
  return normalizeTranslations(translations, options, logError);
}

const normalizeTranslations = (translations, options, logError) => {
  const normalizedTranslations = {};
  const {
    requestedGroups,
    includeDraft,
    requestedLanguages
  } = options;
  const textKey = includeDraft ? "d" : "v";
  const markets = Object.keys(translations);

  try {
    const intersection = requestedLanguages ? requestedLanguages.filter(lang => !markets.includes(lang)) : [];

    if (intersection.length) {
      throw new Error(`requested language(s) ${intersection.join(", ")} could not be found, please check requestedLanguages and applanga to make sure they use the same values`);
    }
  } catch (e) {
    if (logError) {
      console.error(`normalizeTranslations errored on appID=${options.app}:`, e);
    }
  }

  markets.forEach(market => {
    try {
      const entries = requestedGroups.reduce((entries, group) => ({ ...entries,
        ...translations[market]?.[group]?.entries
      }), {});

      for (const [applangaKey, translation] of Object.entries(entries)) {
        entries[applangaKey] = translation?.[textKey] || translation?.v || "";
      }

      normalizedTranslations[market] = entries;
    } catch (e) {
      console.error(`normalizeTranslations errored on appID=${options.app}:`, e);
    }
  });
  return normalizedTranslations;
};

function getTranslationsUrl(configs, environment = PROD) {
  if (!configs.length) {
    throw new Error("configs array is invalid");
  }

  if (environment !== PROD && environment !== QA) {
    throw new Error("environment is invalid");
  }

  let url = (environment === PROD ? prodBaseUrl : qaBaseUrl) + translationsEndpoint;
  configs.forEach((config, i) => {
    if (typeof config.appId !== "string" || !config.appId) {
      throw new Error(`appId is invalid at config index ${i}`);
    }

    if (config.markets && !Array.isArray(config.markets)) {
      throw new Error(`market is invalid at configs index ${i} with appID=${config.appId}`);
    }

    const {
      appId,
      isExpanded,
      markets
    } = config;
    let queries = `${i}[appId]=${appId}`;

    if (isExpanded === true) {
      queries = `${queries}&${i}[isExpanded]=true`;
    }

    if (markets) {
      markets.forEach(market => {
        queries = `${queries}&${i}[markets][]=${market}`;
      });
    }

    const connector = i > 0 ? "&" : "";
    url = url + connector + queries;
  });
  return url;
}